import api from './api';

export const experimentService = {
    getExperiment: async (id) => {
        return await api.get(`/experiments/${id}`);
    },

    startExperiment: async (id) => {
        return await api.post(`/experiments/${id}/start`);
    },

    submitExperiment: async (id, answers, timeTaken) => {
        return await api.post(`/experiments/${id}/submit`, {
            answers,
            time_taken_seconds: timeTaken
        });
    },

    getExperimentAttempts: async (id) => {
        return await api.get(`/experiments/${id}/attempts`);
    }
};